import {
  IGetFieldsRequest, IField, IFieldService, injectSort, injectPagination, injectQuery, IFieldEnum,
  IAutoMapEnumFilter, IAutoMapEnum, IServerSideGetRowsParams
} from '@samc/centricity-core';
import { AjaxHelper, getAllPagination, IPaginatedList } from '@samc/common';

export class ServicingDataFieldService implements IFieldService {
  public constructor(private _helper: AjaxHelper) { }

  public async getFieldCategories(): Promise<string[]> {
    return await this._helper.getData('/internalFields/categories');
  }

  public async getFields(req?: IGetFieldsRequest, params?: IServerSideGetRowsParams): Promise<IPaginatedList<IField>> {
    const query = getAllPagination();
    if (params !== undefined) {
      injectPagination(query, params);
      injectSort(query, params);
      injectQuery(req, params);
    }
    return await this._helper.postData('/internalFields/search', req, query);
  }

  public async getEnumerations<T extends IFieldEnum>(fieldId: number): Promise<T[]> {
    return await this._helper.getData(`/internalFields/${fieldId}/enums`);
  }

  public async addEnumerations<T extends IFieldEnum>(fieldId: number, createdBy: string, ...enumerations: T[]): Promise<T[]> {
    return await this._helper.postData(`/internalFields/${fieldId}/enums`, { enums: enumerations, createdBy });
  }

  public async updateEnumeration<T extends IFieldEnum>(enumId: number, modifiedBy: string, enumeration: T): Promise<T[]> {
    return await this._helper.patchData(`/internalFields/${enumId}/enums`, { enum: enumeration, modifiedBy });
  }

  public async deleteEnumeration(enumId: number, updatedBy: string): Promise<void> {
    await this._helper.delete(`/internalFields/${enumId}/enums/${updatedBy}`);
  }

  /**
   * @inheritdoc
   */
  public async getAutoMapEnums(filter: IAutoMapEnumFilter[], abortController?: AbortController): Promise<IAutoMapEnum[]> {
    return await this._helper.postData<IAutoMapEnum[]>('/automap/enums/search', filter, {}, { signal: abortController?.signal });
  }

  /**
   * @inheritdoc
   */
  public async upsertAutoMapEnums(suggestions: IAutoMapEnum[], user: string): Promise<IAutoMapEnum[]> {
    return await this._helper.postData<IAutoMapEnum[]>('/automap/enums', suggestions, { user });
  }
}